<template>
  <div>
    <p class="title text-left">骨子里就喜欢折腾的上海女人</p>
    <p class="desc text-left">2018-11-22　<span class="author">及时雨小额贷款</span></p>
    <div class="main-content text-left">
      <p class="normal">雨后的空气中，散发出淡淡花香，我们一行人来到坐落在迪士尼附近的一家房车露营俱乐部，一幢幢房车映入眼帘。绿草青青，小桥流水，走过石板路，穿过2座小木桥，就来到了古朴的休息亭。刚接待完客户的王颖正笑吟吟地向我们走来，跟我们讲述了她的创业经历和梦想。</p>
      <div class="normal"><img src="../img/custDetail/1-01.png" width="100%" alt=""></div>
      <p class="bold"><span>骨子里就喜欢折腾的上海女人</span></p>
      <p class="normal">王颖是土生土长的上海人。大学毕业后，第一份工作从事酒店用品贸易，通过这份工作，她意识到酒店市场有很大的利润空间，于是她一边摸索酒店贸易的渠道，一边为自己以后创业做准备。她说：“我骨子里就是一个喜欢折腾的人，大学毕业后就想自己创业，只不过当时并没有好门道，所以选择边上班边寻找机会。”</p>
      <p class="normal">经过几年人脉、渠道的积累，她渐渐摸索到了这一行业的门道，同时在她的心中也埋下了开酒店贸易公司的种子。</p>
      <p class="bold"><span>与朋友合伙，酒店贸易行业初试锋芒</span></p>
      <p class="normal">2006年，骨子里不安分的梦想终于爆发。她跟两个要好的朋友聊天说到想自己创业，在她把创业规划清晰完整表述之后，一下就得到了大家的认可。于是3人一拍即合决定合伙开公司。</p>
      <p class="normal">“因为我有运营经验，所以直接负责整个公司的运营。”在大家的努力下，公司逐步走上正轨。就这样经过四年沉淀，公司发展逐渐扩大，盈利也越来越好。她从一个小资女人成了大家眼中的女强人。“我也从大家口中的小王变成了王总”</p>
      <p class="bold"><span>转型房车露营，追寻吉普赛人的浪漫情节</span></p>
      <p class="normal">机会总是留给有准备的人，她对这句话深信不疑。带着创业者的标签，她不断的寻找新的商机。功夫不负有心人，2013年成为了王颖创业之路的转折点。</p>
      <p class="normal">那一年上海迪士尼开始施工，敏锐的她又嗅到了新的商机，她发现房车露营在国外已经流行很久，但在中国还比较少。吉普赛人的浪漫房车似乎也给了她新的灵感。</p>
      <p class="normal">“我考察了上海的房车露营市场，这里做房车露营的很少，而房车是可移动的非常轻便，只要选择好的地段，一定会有很好的发展。”所以，发现商机之后创业3人帮又开始着手新的创业合作。</p>
      <div class="normal"><img src="../img/custDetail/1-02.png" width="100%" alt=""><p class="text-center">房车外部</p></div>
      <p class="normal">2016年上海迪士尼正式开放，房车露营俱乐部也抢在同时间营业。为了更专业化，她还特意邀请了一位做设计的朋友加入，为俱乐部的环境进行量身打造。并利用自己的经验，为公司的发展提出相对专业的经营手段。“凡事都要从专业的角度考虑。”她坦言道。</p>
      <div class="normal"><img src="../img/custDetail/1-03.png" width="100%" alt=""><p class="text-center">小区绿化环境</p></div>
      <div class="normal"><img src="../img/custDetail/1-04.png" width="100%" alt=""><p class="text-center">房车内部装置</p></div>
      <p class="normal">王颖说到“我们很多房车是进口产品，可移动的，非常的便捷。”同时依托在迪士尼的俱佳位置，也吸引了很多大公司来此进行团建。例如：碧桂园、平安、万科等。“虽然我们的定价略高，但我们的入住率达到75%，在人力成本和房车投入上我们也控制的很好，这让我们的利润也相对较高。”</p>
      <p class="normal">于是她想乘机扩大经营场地，刚好又拿到了第二期的开发权，天时地利人和，一切准备就绪。</p>
      <p class="bold"><span>扩大经营，遭遇资金不足</span></p>
      <p class="normal">正当大家准备摩拳擦掌大干一场的时候，问题也接踵而至，开发第二期意味着需要新的房车设备、装修、人工等。可这些都需要钱，对于王颖来说，一下拿出这么多钱太困难了。</p>
      <p class="normal">几十万的资金缺口就像一个巨石，压在她的心口，生生的疼。“自己创业这么多年，一直都是比较顺利的，从来没有像那段时间这么无助”她说道，“精神压力太大，吃饭吃不下，睡也睡不好，头发还大把大把的掉，那是我最难捱的日子。”</p>
      <p class="normal">期间她也找过各种借款渠道，熟人借钱、银行贷款等都曾尝试过，但都没有解决燃眉之急。“一般从熟人借的钱金额较小，起不了太大作用。银行就更不用说了，光手续就要很久。”她坦言道。</p>
      <p class="normal">就在她一筹莫展之际，在网上偶然看到及时雨小贷一个广告。当时，仅是抱着试一试的态度打通了客服电话，但没想到及时雨小贷第二天就派了信贷经理老邹来了解情况，申请贷款后，又有一批风控人员来考察俱乐部情况。“提交了企业的基本证照、交易流水、银行对账单等，很快就通过了审核，顺利拿到了第二期的扩充资金。”王颖欣慰的说到。王颖房车露营俱乐部第二期预计于 2019年春节前后开始营业。</p>
      <p class="bold"><span>再微小的个体，也能绽放出自己的光芒</span></p>
      <p class="normal">王颖的故事只是我国小微经济发展的一个缩影，但却体现了我国千万计小微企业类似的境遇。如今，在我国政策的重点扶持下，以银行等传统金融机构为主导，新金融从业机构的辅助推动下，惠及小微企业的普惠金融服务越来越健全。不容忽视的是，在这一过程中，网贷机构尽管总量不大，却在扩大普惠金融的服务覆盖面方面起到了不可替代的积极作用，特别是在小微企业、三农等领域。</p>
      <p class="normal">及时雨小贷拥有一支深耕小微金融近20年的核心团队，致力于帮助小微企业解决融资难融资贵的问题，我们也真心希望可以通过自己一点微小的举动，能给他人带来更美好的生活。</p>
      <p class="normal">让普惠金融因为我们的存在而有一些不同，让世界因自己的存在更加美好，是及时雨小贷一直以来的梦想。正如坚守浪漫房车梦想的王颖，我们相信再微小的个体，也能绽放出属于自己的光芒。</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Detail1"
  }
</script>

<style scoped lang="less">
  @import "detail.less";
</style>



// WEBPACK FOOTER //
// src/components/Detail1.vue